export * from './ProductCardV2Description';
